import {
  Button,
  Card,
  CircularProgress,
  Grid,
  Icon,
  IconButton,
  InputAdornment,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
} from "@material-ui/core";
import { AddRounded, MoreHoriz } from "@material-ui/icons";
import clsx from "clsx";
import React, { useEffect, useState } from "react";
import { useCallback } from "react";
import { Form } from "react-bootstrap";
import ScrollBar from "react-perfect-scrollbar";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import Swal from "sweetalert2";

import { MatxMenu } from "../../../../../matx";
import { BackdropLoading, TablePagination } from "../../../../components";
import ModalFileGCG from "../../../../components/modals/ModalFileGCG";
import { delFileGCG, getFileGCG } from "../../../../redux/actions/GCGActions";

const File = ({ location }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [page, setPage] = useState("0");
  const [show, setShow] = useState("25");
  const [search, setSearch] = useState("");
  const [showLoading, setShowLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [editData, setEditData] = useState({});
  const { fileGCG, loadingFileGCG, fileGCGPagination, totalFileGCG } =
    useSelector(({ gcg }) => gcg);

  const getData = useCallback(
    (limit, page, search) => {
      dispatch(getFileGCG({ limit, page, search }));
    },
    [dispatch]
  );

  const showAlert = (text, success) => {
    Swal.fire({
      title: success ? "Berhasil" : "Oopss!",
      text: text,
      imageUrl: `/assets/images/icons/${
        success ? "ic_success" : "ic_error"
      }.svg`,
      imageWidth: 92,
      imageHeight: 92,
      confirmButtonText: "Ok",
      confirmButtonColor: "#0083E2",
    });
  };

  const handleDelete = (code, nama) => {
    Swal.fire({
      title: "Konfirmasi Hapus",
      text: "Apakah anda yakin ingin menghapus data " + nama,
      imageUrl: `/assets/images/icons/ic_delete.svg`,
      imageWidth: 92,
      imageHeight: 92,
      confirmButtonText: "Hapus",
      confirmButtonColor: "#FD6D5D",
      showCancelButton: true,
      cancelButtonText: "Batal",
      cancelButtonColor: "#0083E2",
      reverseButtons: true,
    }).then((res) => {
      if (res.isConfirmed) {
        sendDelete(code);
      }
    });
  };

  const sendDelete = (code) => {
    setShowLoading(true);
    delFileGCG(code)
      .then(() => {
        getData(show, page, search);
        setShowLoading(false);
        showAlert("Berhasil menghapus data", true);
      })
      .catch((err) => {
        let error = err?.response?.data;
        setShowLoading(false);
        showAlert(
          Array.isArray(error?.data)
            ? error?.data[0]
            : "Gagal menghapus data, coba beberapa saat lagi",
          false
        );
      });
  };

  const editShowAction = (data, show) => {
    setIsEdit(true);
    setShowModal(show);
    setEditData(data);
  };

  useEffect(() => {
    let params = new URLSearchParams(location?.search);
    let limit = params.get("limit") || "25";
    let cari = params.get("cari") || "";
    let hal = params.get("hal") ? params.get("hal") : "1";
    setShow(limit);
    setPage(hal);
    setSearch(cari);
    getData(limit, hal, cari);
  }, [location.search, getData]);

  return (
    <div className="m-sm-30">
      <Grid container spacing={4} justifyContent="center">
        <Grid item xs={11} md={10} className="flex items-center">
          <h3 className="fw-bold m-0">GCG - File</h3>
        </Grid>
        <Grid item xs={5} md={2}>
          <Button
            className="btn btn-primary radius-6 text-white font-14 w-full border-radius-0"
            onClick={() => {
              setIsEdit(false);
              setShowModal(true);
            }}
          >
            <AddRounded /> Tambah
          </Button>
        </Grid>
        <Grid item xs={11} md={12}>
          <Card className="w-full pt-6 pb-4 border-radius-0" elevation={0}>
            <Grid
              container
              spacing={2}
              justifyContent="flex-start"
              className="mb-2 px-4"
            >
              <Grid item xs={12} md={4}>
                <form
                  noValidate
                  onSubmit={(e) => {
                    e.preventDefault();
                    history.push(
                      `/gcg_file?hal=${page}&limit=${show}&cari=${search}`
                    );
                  }}
                >
                  <TextField
                    value={search}
                    placeholder="Cari"
                    variant="outlined"
                    onChange={({ target: { value } }) => setSearch(value)}
                    size="small"
                    className="w-full"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton size="small" type="submit">
                            <Icon size="small" color="action">
                              search
                            </Icon>
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </form>
              </Grid>
            </Grid>
            <ScrollBar className="flex-grow flex-column relative h-full">
              <Table className={clsx("whitespace-pre min-w-750")}>
                <TableHead>
                  <TableRow>
                    <TableCell align="center" className="w-90 border-b">
                      No
                    </TableCell>
                    <TableCell className="border-b">Judul[ID]</TableCell>
                    <TableCell className="border-b">Judul[EN]</TableCell>
                    <TableCell className="border-b">Berkas</TableCell>
                    <TableCell className="border-b w-90" align="center">
                      Aksi
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {loadingFileGCG ? (
                    <TableRow hover>
                      <TableCell className="px-0" align="center" colSpan={5}>
                        <CircularProgress size={25} color="primary" />
                      </TableCell>
                    </TableRow>
                  ) : fileGCG?.length <= 0 ? (
                    <TableRow hover>
                      <TableCell className="px-0" align="center" colSpan={5}>
                        Data kosong.
                      </TableCell>
                    </TableRow>
                  ) : (
                    fileGCG?.map((item, i) => (
                      <TableRow hover key={item.cgg_code}>
                        <TableCell className="px-0" align="center">
                          {show * (page - 1) + (i + 1)}
                        </TableCell>
                        <TableCell className="px-0">{item.title_id}</TableCell>
                        <TableCell className="px-0">{item.title_en}</TableCell>
                        <TableCell className="px-0">
                          {item.file ? (
                            <a
                              href={item.file}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="text-primary"
                            >
                              {item.title}.pdf
                            </a>
                          ) : (
                            "-"
                          )}
                        </TableCell>
                        <TableCell className="px-0" align="center">
                          <MatxMenu
                            menuButton={
                              <div className="flex items-center">
                                <IconButton size="small">
                                  <MoreHoriz />
                                </IconButton>
                              </div>
                            }
                            horizontalPosition="right"
                          >
                            <MenuItem
                              className="popup-menu-item"
                              onClick={() => {
                                editShowAction(item, true);
                              }}
                            >
                              <img
                                src="/assets/images/icons/ic_action_edit.svg"
                                alt="icon edit"
                              />
                              <span className="pl-4"> Edit </span>
                            </MenuItem>
                            <MenuItem>
                              <Link
                                to={"/gcg_file" + location?.search}
                                onClick={() =>
                                  handleDelete(item.cgg_code, item.title)
                                }
                                className="popup-menu-item"
                              >
                                <img
                                  src="/assets/images/icons/ic_action_delete.svg"
                                  alt="icon hapus"
                                />
                                <span className="pl-4"> Hapus </span>
                              </Link>
                            </MenuItem>
                          </MatxMenu>
                        </TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </ScrollBar>
            <Grid container spacing={2} className="mt-2 px-6">
              <Grid
                item
                xs={12}
                className="flex justify-center justify-content-lg-between items-center"
              >
                {loadingFileGCG ? (
                  <p className="text-muted m-0 d-none d-lg-block">
                    Mengambil Data...
                  </p>
                ) : (
                  <p className="text-muted m-0 d-none d-lg-block">
                    Menampilkan {parseInt(show) * (parseInt(page) - 1) + 1}{" "}
                    sampai {parseInt(page) * parseInt(show)} dari {totalFileGCG}{" "}
                    data
                  </p>
                )}
                <div className="d-flex justify-content-end container-pagination mt-4 flex-column flex-md-row items-center">
                  <div className="d-flex align-items-center mb-3">
                    <p className="m-0 mr-2">Tampilkan</p>
                    <Form.Select
                      aria-label="Tampilkan"
                      className="font-14 border-radius-0"
                      value={show}
                      onChange={({ target: { value } }) =>
                        history.push(
                          `/gcg_file?hal=${page}&limit=${value}&cari=${search}`
                        )
                      }
                    >
                      <option value="100">100</option>
                      <option value="25">25</option>
                      <option value="10">10</option>
                      <option value="5">5</option>
                    </Form.Select>
                  </div>
                  <TablePagination
                    href="/gcg_file"
                    page={page}
                    params={`&limit=${show}&cari=${search}`}
                    total={fileGCGPagination}
                  />
                </div>
              </Grid>
            </Grid>
          </Card>
        </Grid>
      </Grid>
      <BackdropLoading open={showLoading} />

      <ModalFileGCG
        handleClose={() => {
          setIsEdit(false);
          setShowModal(false);
          getData(show, page, search);
          setEditData({});
        }}
        open={showModal}
        data={editData}
        isEdit={isEdit}
      />
    </div>
  );
};

export default File;
